import { axios } from "../config/axios";

const endPoint = '/project/drive';

const createDrive = async (body) => {
    return axios.post(`${endPoint}`, body);
}

const getAll = async () => {
    return axios.get(`${endPoint}`);
}

export {
    createDrive,
    getAll,
}